import { render, staticRenderFns } from "./modalBase1.vue?vue&type=template&id=4821e8f6&scoped=true&"
import script from "./modalBase1.vue?vue&type=script&lang=js&"
export * from "./modalBase1.vue?vue&type=script&lang=js&"
import style0 from "./modalBase1.vue?vue&type=style&index=0&id=4821e8f6&prod&lang=scss&scoped=true&"
import style1 from "./modalBase1.vue?vue&type=style&index=1&id=4821e8f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821e8f6",
  null
  
)

export default component.exports